<div class="nav_container">
  <div>
    <ul>
      <div class="mb-4">
        <li class="uppercase text-greyLighter text-sm font-bold mb-1">
          Outils
        </li>
        <li>
          <a
            [routerLink]="['agenda/apprenant']"
            class="nav_item"
            routerLinkActive="active-link"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
              <path
                fill="#E5E8EC"
                stroke="black"
                stroke-width="6"
                d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l352 0 0 256c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256z"
              />
            </svg>
            <span class="ml-3">Agenda</span>
          </a>
        </li>
        <li>
          <a href="" target="_blank" class="nav_item">
            <svg
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 20 19"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                d="m9 12 5.419 3.871A1 1 0 0 0 16 15.057V2.943a1 1 0 0 0-1.581-.814L9 6m0 6V6m0 6H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h7m-5 6h3v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-5Zm15-3a3 3 0 0 1-3 3V6a3 3 0 0 1 3 3Z"
              />
            </svg>
            <span class="ml-3">Actualités</span>
          </a>
        </li>
        <li>
          <a
            [routerLink]="['users/portfolio']"
            class="nav_item"
            routerLinkActive="active-link"
          >
            <svg
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 20 19"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                d="m9 12 5.419 3.871A1 1 0 0 0 16 15.057V2.943a1 1 0 0 0-1.581-.814L9 6m0 6V6m0 6H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h7m-5 6h3v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-5Zm15-3a3 3 0 0 1-3 3V6a3 3 0 0 1 3 3Z"
              />
            </svg>
            <span class="ml-3">Mon portfolio</span>
          </a>
        </li>
      </div>
      <!-- AMI -->
      <div class="mb-4">
        <li class="uppercase text-greyLighter text-sm font-bold mb-1">AMI</li>
        <li>
          <a
            [routerLink]="['ami/listeami']"
            class="nav_item"
            routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <svg
              width="28"
              height="28"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.7"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <line x1="8" y1="6" x2="21" y2="6" />
              <line x1="8" y1="12" x2="21" y2="12" />
              <line x1="8" y1="18" x2="21" y2="18" />
              <circle cx="3" cy="6" r="1.5" />
              <circle cx="3" cy="12" r="1.5" />
              <circle cx="3" cy="18" r="1.5" />
            </svg>
            <span class="ml-3">Liste AMI</span>
          </a>
        </li>
        <li>
          <a
            [routerLink]="['ami/activitepart']"
            class="nav_item"
            routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              version="1.1"
              viewBox="0 0 24 22.7"
            >
              <defs>
                <style>
                  .cls-1 {
                    fill: #e5e7eb;
                  }
                </style>
              </defs>
              <!-- Generator: Adobe Illustrator 28.7.1, SVG Export Plug-In . SVG Version: 1.2.0 Build 142)  -->
              <g>
                <g id="Calque_1">
                  <g>
                    <path
                      class="cls-1"
                      d="M17.8,4.3v-1.3c0-.4-.3-.8-.8-.8s-.8.3-.8.8v1.2H7.8v-1.2c0-.4-.3-.8-.8-.8s-.8.3-.8.8v1.3c-2.3.4-4,2.3-4,4.7v8c0,2.6,2.1,4.8,4.8,4.8h10c2.6,0,4.8-2.1,4.8-4.8h0v-8c0-2.3-1.7-4.3-4-4.7ZM7,5.8h10c1.5,0,2.8,1,3.1,2.5H3.8c.3-1.5,1.6-2.5,3.2-2.5ZM17,20.3H7c-1.8,0-3.2-1.5-3.2-3.2v-7.2h16.5v7.2c0,1.8-1.5,3.2-3.2,3.2Z"
                    />
                    <path
                      class="cls-1"
                      d="M14.5,12.5l-3.5,3.5-1.5-1.5c-.3-.3-.8-.3-1.1,0-.3.3-.3.7,0,1l2,2c.3.3.8.3,1.1,0l4-4c.3-.3.3-.8,0-1.1-.3-.3-.7-.3-1,0Z"
                    />
                  </g>
                </g>
              </g>
            </svg>
            <span class="ml-3">Activités mensuelles</span>
          </a>
        </li>
        <li>
          <a
            [routerLink]="['ami/conventionpartenaire']"
            class="nav_item"
            routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <svg
              width="28"
              height="28"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.7"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <line x1="8" y1="6" x2="21" y2="6" />
              <line x1="8" y1="12" x2="21" y2="12" />
              <line x1="8" y1="18" x2="21" y2="18" />
              <circle cx="3" cy="6" r="1.5" />
              <circle cx="3" cy="12" r="1.5" />
              <circle cx="3" cy="18" r="1.5" />
            </svg>
            <span class="ml-3">Ma convention</span>
          </a>
        </li>

        <!-- END AMI -->
      </div>
      <!-- PLATEFORME LMS -->
      <!-- Scholar Vox -->
      <!-- <div class="mb-4">
        <li class="uppercase text-greyLighter text-sm font-bold mb-1">
          Plateforme LMS
        </li>
        <div>
          <ul>
            <li>
              <button
                class="nav_item text-left"
                (click)="openUrl(urlScholarVox)"
              >
                <svg
                  viewBox="0 0 32 32"
                  xmlns="http://www.w3.org/2000/svg"
                  style="transform: scale(1.1)"
                >
                  <path
                    fill="#E5E8EC"
                    d="M27,4H17V3a1,1,0,0,0-2,0V4H5A3,3,0,0,0,2,7V23a3,3,0,0,0,3,3h6.7l-1.55,2.47a1,1,0,0,0,.32,1.38,1,1,0,0,0,1.38-.32L14.05,26H18l2.2,3.53a1,1,0,0,0,1.38.32,1,1,0,0,0,.32-1.38L20.3,26H27a3,3,0,0,0,3-3V7A3,3,0,0,0,27,4ZM4,7A1,1,0,0,1,5,6H27a1,1,0,0,1,1,1V20H26V19a3,3,0,0,0-3-3H21a3,3,0,0,0-3,3v1H4ZM24,20H20V19a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1Zm4,3a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V22H28Z"
                  />
                </svg>
                <span>Scholar Vox</span>
              </button>
            </li>
          </ul>
        </div>
      </div> -->
    </ul>
  </div>

  <!--  Compte -->
  <div>
    <ul>
      <div class="mb-4">
        <div>
          <li class="uppercase text-greyLighter text-sm font-bold mb-1">
            Compte
          </li>
          <li>
            <a
              [routerLink]="['users/profil']"
              class="nav_item"
              routerLinkActive="active-link"
            >
              <svg
                class="text-greyLighter"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 18"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.5"
                  d="M7 8a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm-2 3h4a4 4 0 0 1 4 4v2H1v-2a4 4 0 0 1 4-4Z"
                />
              </svg>
              <span class="ml-3">Mon Profil</span>
            </a>
          </li>
        </div>
      </div>
    </ul>
  </div>
</div>
